import { OktaError } from './types'

export const isLoginRequiredError = (err: OktaError) => err.cause?.message?.includes('login_required')
export const isNotFoundError = (err: OktaError) => err.cause?.message?.includes('AuthApiError')
export const isNoTokenError = (err: OktaError) =>
  err.cause?.message?.includes('AuthSdkError') && err.cause?.message?.includes('Unable to parse a token from the url')
